module.exports = __webpack_public_path__ + "static/media/movieType-foreign.c0356f72.jpg";